import moment from "moment";
import React from "react";
import { marpolUtils } from "../../../../../redux/app/marpol";
import {
	TCRBRecord,
	ECRBRecordState,
} from "../../../../../redux/app/crb/@types";
import { TCRBK1 } from "../../../../../redux/app/crb/groups/crb-k";
import CRBTableRows, { CRBTableColumns } from "../CRBTableRows";
import CRBPreviewer from "../CRBPreviewer";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBK1PreviewProps = OwnProps;
function CRBK1Preview(props: CRBK1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBK1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	const dateOfOriginalOperation = moment(
		crbRecord.itemO2.dateOfOriginalOperation,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<>
				<CRBTableRows
					record={crbRecord}
					tableRows={[
						[dateOfOriginalOperation, "K", "-", renderItemMain()],
						[...renderMissedPlaceholder()],
						[null, null, "NOTE", crbRecord.remarks],
					]}
				/>
				{renderMissedRecord()}
			</>
		);
	}
	function renderItemMain() {
		return (
			<h4 className="font-medium uppercase">
				{/*  This entry key/value validation is a quickfix and stopgap solution for vessel arctic, this validation will be
              refactored and types will be also be corrected */}
				ENTRY PERTAINING TO AN EARLIER MISSED OPERATIONAL ENTRY
				{crbRecord.itemO2.receiptAttachment &&
				crbRecord.itemO2.receiptAttachment !== " " ? (
					<>
						<br />
						CORRECTION NOTE:{" "}
						<a
							href={marpolUtils.getAttachmentURL(
								crbRecord.itemO2.receiptAttachment,
								crbRecord.id,
								crbRecord._rev
							)}
							download={crbRecord.itemO2.receiptAttachment}
						>
							{" "}
							{crbRecord.itemO2.receiptAttachment}
						</a>
					</>
				) : null}
			</h4>
		);
	}

	function renderMissedPlaceholder(): CRBTableColumns {
		const canShowPlaceholder =
			crbRecord.itemO2.isAnMissedEntryRecord && !crbRecord.itemO2.missedRecord;
		if (!canShowPlaceholder) return [null, null, null, null];

		const content = (
			<h4 className="font-medium text-gray-500 uppercase">
				<div className="flex flex-row items-center justify-center p-6 px-12 font-medium text-center bg-gray-100 border-2 border-gray-400 border-dashed">
					<div>MISSED ENTRY WILL APPEAR HERE</div>
					<span className="ml-6 text-gray-400 bp3-icon bp3-icon-time"></span>
				</div>
			</h4>
		);

		return [
			operationDate,
			<div className="text-gray-500">?</div>,
			<div className="text-gray-500">?</div>,
			content,
		];
	}

	function renderMissedRecord() {
		if (!crbRecord.itemO2.missedRecord) return null;
		return (
			<CRBPreviewer
				crbRecord={{
					...crbRecord.itemO2.missedRecord,
					selectedDate: crbRecord.selectedDate,
					state: props.isStrikedOff
						? ECRBRecordState.STRIKED_OFF
						: crbRecord.itemO2.missedRecord.state,
				}}
			/>
		);
	}

	return renderMain();
}

export default CRBK1Preview;
